module.exports = __webpack_public_path__ + "legacy.2Hxcwbrc.svg";